import {mutations} from './mutations';
import {actions} from './actions';
import {getters} from './getters';

const state = {

    projectsLoading: false,
    projectsCacheExpires: null,
    projects: [],

    projectQuotas: [],
    projectQuotasCacheExpires: null,

    activeTabModel: 0,

    activeTableSearch: '',

    activeTableOptions: {
        page: 1,
        sortBy: ['completed_percent'],
        sortDesc: [true],
        itemsPerPage: 10,
        mustSort: true,
    },

    activeTableFilters: [
        {type: 'responsible', name: 'Responsible for', model: true},
        {type: 'mine', name: 'Managed by me', model: false},
        {type: 'others', name: 'Managed by others', model: false},
        {type: 'online', name: 'Online', model: false},
        {type: 'offline', name: 'Offline', model: false},
        {type: 'closed', name: 'Closed', model: false},
    ],

    archivedProjects: [],
    archivedTableSearch: '',
    archivedTableOptions: {
        page: 1,
        sortBy: ['end_date'],
        sortDesc: [true],
        itemsPerPage: 10,
        mustSort: true
    },

    categoriesLoading: false,
    categoriesCacheExpires: null,
    categories: [],

    projectStats: [],
    projectStatsLoading: false,
    projectStatsCacheExpires: null,

    projectGeoStats: [],
    projectGeoStatsLoading: false,
    projectGeoStatsCacheExpires: null,

    projectSupplierStats: [],
    projectSupplierStatsLoading: false,
}

export default {
    namespaced: true,

    state,
    getters,
    actions,
    mutations
}

